import React, { useEffect } from "react";
import { TextInput } from "react-admin";
import { useField } from "react-final-form";

interface INoteInput {
  record: any;
}

const NoteInput = ({ record }: INoteInput) => {
  const {
    input: { onChange },
  } = useField("note");

  useEffect(() => {
    if (record) {
      if (record.note) {
        onChange(record.note);
      }
    }
  }, [record]);

  return <TextInput label="Note" source="note" />;
};

export default NoteInput;
